export const categories = [
  {
    slug: 'rumen-zhinan',
    name: '入门指南',
    description: '从零开始了解91暗，掌握基础概念与操作流程',
    icon: 'ri-guide-line',
    count: 12,
  },
  {
    slug: 'ziyuan-tuijian',
    name: '资源推荐',
    description: '精选91暗相关优质资源，一站式获取所需内容',
    icon: 'ri-database-2-line',
    count: 18,
  },
  {
    slug: 'rukou-dizhi',
    name: '入口地址',
    description: '整理最新91暗入口与访问渠道，确保畅通无阻',
    icon: 'ri-links-line',
    count: 8,
  },
  {
    slug: 'shiyong-jiqiao',
    name: '使用技巧',
    description: '分享91暗高效使用技巧与进阶玩法，事半功倍',
    icon: 'ri-lightbulb-line',
    count: 15,
  },
  {
    slug: 'changjian-wenti',
    name: '常见问题',
    description: '解答91暗使用过程中的高频疑问，快速排忧解难',
    icon: 'ri-question-answer-line',
    count: 10,
  },
  {
    slug: 'zuixin-dongtai',
    name: '最新动态',
    description: '追踪91暗相关的最新变化、更新与行业趋势',
    icon: 'ri-flashlight-line',
    count: 6,
  },
];

export const articles = [
  {
    id: 1,
    slug: '91an-shi-shenme-wanzheng-jiedu',
    title: '91暗是什么？一文读懂91暗的完整解读',
    excerpt: '91暗作为当前互联网上备受关注的搜索热词，其背后蕴含的内容生态和使用方式值得深入了解。本文将为您全面剖析91暗的概念起源、核心功能和实际应用场景。',
    content: `<p>在当今互联网信息爆炸的时代，<strong>91暗</strong>成为了众多用户搜索和关注的热门关键词。那么，91暗究竟是什么？它为何能引起如此广泛的关注？本文将从多个维度为您进行深度解析。</p>

<h2>91暗的概念起源</h2>
<p>91暗这一概念的形成并非一蹴而就。它源于特定的互联网生态和用户需求，经过长期的发展和演变，逐渐形成了今天我们所熟知的面貌。理解91暗的概念起源，有助于我们更好地把握其本质特征。</p>
<p>从词源角度来看，"91"与"暗"的组合蕴含着特定的文化内涵和技术指向。这种命名方式反映了该领域的某些独特属性，也为其赋予了辨识度极高的品牌标签。</p>

<h2>91暗的核心特征</h2>
<p>深入分析91暗，可以发现其具有以下几个显著特征：</p>
<ul>
<li><strong>内容丰富性：</strong>91暗涵盖了大量的信息和资源，用户可以在其中找到各种符合自身需求的内容。</li>
<li><strong>访问便捷性：</strong>通过特定的91暗入口，用户可以快速抵达目标页面，体验流畅的浏览过程。</li>
<li><strong>社区互动性：</strong>91暗不仅仅是单向的信息展示，更是一个具备社交属性的互动平台。</li>
<li><strong>持续更新性：</strong>91暗的内容和功能会定期迭代更新，确保用户始终能够获得最新的体验。</li>
</ul>

<h2>91暗的使用场景</h2>
<p>91暗在实际应用中有着广泛的使用场景。无论是信息检索、资源获取，还是休闲娱乐，91暗都能提供相应的支持。了解这些使用场景，可以帮助用户更好地利用91暗来满足自身需求。</p>

<h2>如何安全使用91暗</h2>
<p>在使用91暗的过程中，安全和隐私保护是不可忽视的重要议题。建议用户选择官方认可的91暗入口和渠道，避免通过不明来源的链接访问，以确保个人信息和上网安全。</p>`,
    category: 'rumen-zhinan',
    categoryName: '入门指南',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20information%20concept%20with%20abstract%20geometric%20shapes%2C%20warm%20amber%20and%20cream%20tones%2C%20soft%20gradient%20background%2C%20clean%20editorial%20style%2C%20knowledge%20and%20discovery%20theme&width=800&height=480&seq=article-01&orientation=landscape',
    author: '91暗指南编辑部',
    date: '2026-08-01',
    readTime: '8分钟',
    featured: true,
  },
  {
    id: 2,
    slug: '91an-rukou-zuixin-dizhi-2026',
    title: '91暗入口最新地址汇总（2026年8月更新）',
    excerpt: '本文整理了91暗入口的最新地址信息，帮助用户快速找到正确的访问渠道。所有地址均经过验证，确保可用性和安全性，是您访问91暗的必备参考。',
    content: `<p>对于广大用户来说，找到正确的<strong>91暗入口</strong>是使用该平台的第一步。本文将为您整理最新的91暗入口地址信息，确保您能够顺利访问。</p>

<h2>为什么91暗入口会变化？</h2>
<p>互联网环境复杂多变，各类平台的访问地址可能会因多种原因发生变更。91暗入口也不例外，了解地址变化的原因，有助于您更好地应对访问过程中的各种情况。</p>

<h2>2026年8月最新91暗入口</h2>
<p>经过我们团队的验证和整理，以下是目前可用的91暗入口信息：</p>
<ul>
<li>主入口地址：经过严格验证的主要访问渠道</li>
<li>备用入口地址：在主要入口不可用时的备选方案</li>
<li>镜像站点地址：分布在不同区域的镜像访问点</li>
</ul>
<p>建议用户将这些入口地址妥善保存，以便随时使用。</p>

<h2>如何验证91暗入口的真实性</h2>
<p>网络上存在着大量虚假或仿冒的91暗入口，使用这些非官方渠道可能会带来安全风险。本文将教您几种简单有效的验证方法，帮助您识别真实的91暗入口。</p>

<h2>访问91暗入口的注意事项</h2>
<p>在访问91暗入口时，有一些事项需要特别注意。遵循这些建议，可以让您的访问体验更加顺畅和安全。</p>`,
    category: 'rukou-dizhi',
    categoryName: '入口地址',
    image: 'https://readdy.ai/api/search-image?query=Modern%20clean%20digital%20navigation%20concept%20with%20connected%20nodes%20and%20pathways%2C%20warm%20earthy%20tones%2C%20minimalist%20geometric%20design%2C%20soft%20lighting%2C%20professional%20editorial%20style&width=800&height=480&seq=article-02&orientation=landscape',
    author: '91暗指南编辑部',
    date: '2026-08-03',
    readTime: '6分钟',
    featured: true,
  },
  {
    id: 3,
    slug: '91an-ziyuan-zhengli-tuijian',
    title: '91暗资源整理推荐：精选优质内容合集',
    excerpt: '面对海量的91暗资源，如何快速找到高质量的内容？本文为您精心筛选和整理了91暗资源推荐清单，涵盖多个分类，助您高效获取所需。',
    content: `<p>随着<strong>91暗资源</strong>的不断丰富，用户面临着如何从海量内容中筛选出优质资源的问题。本文将为您提供一份精心整理的91暗资源推荐清单。</p>

<h2>91暗资源分类概览</h2>
<p>91暗资源可以按照不同的维度进行分类。了解这些分类方式，有助于您更有针对性地查找所需内容。</p>

<h2>精选资源推荐</h2>
<p>以下是经过我们团队严格筛选的91暗优质资源：</p>
<ul>
<li><strong>入门教程类：</strong>适合新用户的91暗基础教程和操作指南</li>
<li><strong>进阶技巧类：</strong>面向有一定经验用户的高级使用技巧</li>
<li><strong>工具辅助类：</strong>提升91暗使用效率的辅助工具和插件</li>
<li><strong>社区交流类：</strong>91暗用户交流和分享的社区平台</li>
</ul>

<h2>如何高效利用91暗资源</h2>
<p>获取优质的91暗资源只是第一步，更重要的是如何高效地利用这些资源。本文将分享一些实用的资源管理和使用策略，帮助您最大化资源价值。</p>`,
    category: 'ziyuan-tuijian',
    categoryName: '资源推荐',
    image: 'https://readdy.ai/api/search-image?query=Clean%20organized%20digital%20resource%20library%20concept%2C%20minimalist%20grid%20layout%20with%20cards%2C%20warm%20neutral%20color%20palette%2C%20soft%20shadows%20and%20elegant%20typography%2C%20editorial%20design&width=800&height=480&seq=article-03&orientation=landscape',
    author: '91暗指南编辑部',
    date: '2026-07-28',
    readTime: '10分钟',
    featured: false,
  },
  {
    id: 4,
    slug: '91an-shiyong-jiqiao-gaoxiao',
    title: '91暗使用技巧大全：从入门到精通',
    excerpt: '想要更高效地使用91暗？本文汇总了从基础操作到进阶玩法的全套91暗使用技巧，无论您是新手还是老用户，都能从中获益。',
    content: `<p>掌握正确的<strong>91暗使用技巧</strong>，可以让您的使用体验事半功倍。本文将从基础操作到进阶玩法，为您全面介绍91暗的使用技巧。</p>

<h2>基础操作技巧</h2>
<p>对于刚接触91暗的新用户，掌握以下基础操作技巧非常重要：</p>
<ul>
<li>账号注册与设置的优化方法</li>
<li>界面导航的快捷操作方式</li>
<li>内容搜索的高效技巧</li>
<li>个人信息管理的最佳实践</li>
</ul>

<h2>进阶使用技巧</h2>
<p>当您熟悉了基础操作后，可以尝试以下进阶技巧来提升使用效率：</p>
<ul>
<li>高级搜索语法的运用</li>
<li>内容过滤与个性化定制</li>
<li>多设备同步与数据管理</li>
<li>社区互动与资源分享策略</li>
</ul>

<h2>常见误区与避坑指南</h2>
<p>在使用91暗的过程中，一些常见的误区可能会影响您的体验。了解这些误区并学会避免，可以让您的使用之路更加顺畅。</p>`,
    category: 'shiyong-jiqiao',
    categoryName: '使用技巧',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20productivity%20and%20skill%20learning%20concept%2C%20warm%20cream%20and%20amber%20tones%2C%20geometric%20abstract%20shapes%2C%20clean%20editorial%20photography%20style%2C%20knowledge%20sharing%20theme&width=800&height=480&seq=article-04&orientation=landscape',
    author: '91暗指南编辑部',
    date: '2026-07-25',
    readTime: '12分钟',
    featured: false,
  },
  {
    id: 5,
    slug: '91an-changjian-wenti-jieda',
    title: '91暗常见问题解答：您关心的都在这里',
    excerpt: '针对用户关于91暗的高频疑问，我们整理了这份详细的常见问题解答。从访问问题到使用困惑，一站式为您排忧解难。',
    content: `<p>在使用<strong>91暗</strong>的过程中，用户常常会遇到各种疑问。本文整理了最常见的91暗相关问题并给出详细解答，希望能帮助您解决困惑。</p>

<h2>访问相关问题</h2>
<p><strong>问：为什么有时候无法访问91暗入口？</strong></p>
<p>答：这可能由多种原因导致，包括网络波动、服务器维护或入口地址更新。建议检查网络连接，或尝试使用备用入口地址。</p>

<p><strong>问：如何确认使用的91暗入口是官方渠道？</strong></p>
<p>答：可以通过官方发布的验证信息来确认入口的真实性。避免使用来源不明的链接。</p>

<h2>使用相关问题</h2>
<p><strong>问：91暗是否支持多设备同时使用？</strong></p>
<p>答：是的，91暗支持在多台设备上使用，但需要注意账号安全，避免在公共设备上保存登录信息。</p>

<p><strong>问：如何提高91暗的使用效率？</strong></p>
<p>答：可以参考我们的使用技巧指南，学习高级搜索方法、快捷键操作等内容。</p>

<h2>安全相关问题</h2>
<p><strong>问：使用91暗时如何保护个人隐私？</strong></p>
<p>答：建议使用强密码、开启双重验证、定期清理浏览记录，并避免在不安全的网络环境下使用。</p>`,
    category: 'changjian-wenti',
    categoryName: '常见问题',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20FAQ%20and%20help%20concept%20with%20question%20marks%20and%20dialogue%20bubbles%2C%20warm%20neutral%20tones%2C%20clean%20geometric%20design%2C%20soft%20ambient%20lighting%2C%20professional%20editorial%20style&width=800&height=480&seq=article-05&orientation=landscape',
    author: '91暗指南编辑部',
    date: '2026-07-20',
    readTime: '7分钟',
    featured: false,
  },
  {
    id: 6,
    slug: '91an-zuixin-dongtai-gengxin-2026',
    title: '91暗最新动态：2026年下半年更新前瞻',
    excerpt: '91暗平台近期有哪些新变化？未来将推出哪些新功能？本文汇总了91暗最新动态，让您掌握第一手信息。',
    content: `<p>关注<strong>91暗最新动态</strong>，可以帮助用户及时了解平台的变化和新功能。本文将为您汇总近期的重要更新和未来规划。</p>

<h2>近期重要更新</h2>
<p>91暗平台在近期进行了多项重要更新，包括界面优化、功能增强和性能提升。这些更新旨在为用户提供更好的使用体验。</p>

<h2>即将推出的新功能</h2>
<p>根据官方透露的信息，91暗将在未来几个月内推出以下新功能：</p>
<ul>
<li>更智能的内容推荐算法</li>
<li>增强的社区互动功能</li>
<li>移动端体验的全面优化</li>
<li>更多个性化的定制选项</li>
</ul>

<h2>行业趋势分析</h2>
<p>从更宏观的角度来看，91暗所在领域正经历着快速的发展和变革。了解这些行业趋势，有助于您更好地把握91暗的未来发展方向。</p>`,
    category: 'zuixin-dongtai',
    categoryName: '最新动态',
    image: 'https://readdy.ai/api/search-image?query=Modern%20futuristic%20update%20and%20innovation%20concept%2C%20abstract%20flowing%20shapes%20in%20warm%20amber%20and%20cream%20tones%2C%20minimalist%20design%2C%20dynamic%20movement%20feeling%2C%20editorial%20photography&width=800&height=480&seq=article-06&orientation=landscape',
    author: '91暗指南编辑部',
    date: '2026-08-04',
    readTime: '5分钟',
    featured: true,
  },
  {
    id: 7,
    slug: '91an-xinshou-shangshou-gonglue',
    title: '91暗新手上手攻略：30分钟快速入门',
    excerpt: '刚刚接触91暗？这份专为新用户设计的快速入门攻略，将带您在30分钟内掌握91暗的核心操作和基本使用方法。',
    content: `<p>如果您是第一次接触<strong>91暗</strong>，可能会感到有些不知所措。别担心，这份新手上手攻略将帮助您在30分钟内快速入门。</p>

<h2>第一步：了解基本概念</h2>
<p>在开始使用之前，先花几分钟了解91暗的基本概念和术语，这将帮助您更快地上手。</p>

<h2>第二步：完成初始设置</h2>
<p>按照以下步骤完成91暗的初始设置，为后续使用打下良好基础。</p>

<h2>第三步：探索核心功能</h2>
<p>逐一了解91暗的核心功能模块，掌握最基本的操作流程。</p>

<h2>第四步：建立使用习惯</h2>
<p>养成良好的使用习惯，可以让您在91暗的使用过程中事半功倍。</p>`,
    category: 'rumen-zhinan',
    categoryName: '入门指南',
    image: 'https://readdy.ai/api/search-image?query=Beginner%20friendly%20learning%20concept%20with%20step%20by%20step%20guide%2C%20warm%20cream%20background%2C%20minimalist%20flat%20design%2C%20geometric%20elements%2C%20soft%20and%20inviting%20atmosphere&width=800&height=480&seq=article-07&orientation=landscape',
    author: '91暗指南编辑部',
    date: '2026-07-18',
    readTime: '6分钟',
    featured: false,
  },
  {
    id: 8,
    slug: '91an-gaoji-wanjia-jinjie-zhinan',
    title: '91暗高级玩家进阶指南：解锁隐藏功能',
    excerpt: '已经熟悉91暗的基本操作？这篇进阶指南将带您探索91暗的隐藏功能和高级玩法，让您的使用体验更上一层楼。',
    content: `<p>对于已经熟练使用<strong>91暗</strong>基本功能的用户来说，是时候探索更多高级玩法了。本文将为您揭示91暗的隐藏功能和进阶技巧。</p>

<h2>隐藏功能一览</h2>
<p>91暗中隐藏着许多不为人知但非常实用的功能，了解这些功能可以大幅提升您的使用体验。</p>

<h2>高级搜索技巧</h2>
<p>掌握高级搜索技巧，可以帮助您在91暗的海量内容中精准定位所需信息。</p>

<h2>效率提升秘籍</h2>
<p>学会以下效率提升技巧，让您在91暗上的操作更加快速流畅。</p>`,
    category: 'shiyong-jiqiao',
    categoryName: '使用技巧',
    image: 'https://readdy.ai/api/search-image?query=Advanced%20expert%20level%20digital%20concept%20with%20unlocking%20hidden%20features%2C%20warm%20golden%20and%20cream%20tones%2C%20abstract%20geometric%20patterns%2C%20elegant%20editorial%20style&width=800&height=480&seq=article-08&orientation=landscape',
    author: '91暗指南编辑部',
    date: '2026-07-15',
    readTime: '9分钟',
    featured: false,
  },
  {
    id: 9,
    slug: '91an-anquan-shiyong-zhinan',
    title: '91暗安全使用指南：保护您的隐私与数据',
    excerpt: '在享受91暗带来的便利时，安全问题不容忽视。本文详细介绍了91暗安全使用的最佳实践，帮助您保护个人隐私和数据安全。',
    content: `<p>在数字时代，<strong>91暗安全使用</strong>是每位用户都应该重视的话题。本文将从多个角度为您提供全面的安全使用建议。</p>

<h2>账户安全设置</h2>
<p>保护您的91暗账户安全是第一步。以下是一些关键的账户安全设置建议。</p>

<h2>隐私保护策略</h2>
<p>了解并正确配置隐私设置，可以有效保护您的个人信息不被泄露。</p>

<h2>安全上网建议</h2>
<p>在使用91暗的过程中，遵循以下安全上网建议可以大大降低风险。</p>`,
    category: 'changjian-wenti',
    categoryName: '常见问题',
    image: 'https://readdy.ai/api/search-image?query=Digital%20security%20and%20privacy%20protection%20concept%2C%20shield%20and%20lock%20symbols%20in%20minimalist%20style%2C%20warm%20neutral%20tones%2C%20clean%20design%2C%20trustworthy%20and%20safe%20feeling&width=800&height=480&seq=article-09&orientation=landscape',
    author: '91暗指南编辑部',
    date: '2026-07-10',
    readTime: '8分钟',
    featured: false,
  },
  {
    id: 10,
    slug: '91an-shequ-hudong-wanquan-jiexi',
    title: '91暗社区互动完全解析：从参与到共建',
    excerpt: '91暗的社区是其核心魅力之一。本文全面解析91暗社区互动的各种玩法，教您如何从普通用户成长为社区共建者。',
    content: `<p><strong>91暗社区</strong>是该平台最具活力的组成部分。本文将带您深入了解91暗社区的互动方式和文化特色。</p>

<h2>社区基本规则</h2>
<p>在参与91暗社区互动之前，了解社区的基本规则和礼仪非常重要。</p>

<h2>互动方式详解</h2>
<p>91暗社区提供了多种互动方式，每种方式都有其独特的价值和使用场景。</p>

<h2>从用户到共建者</h2>
<p>如果您希望更深入地参与91暗社区，可以尝试从普通用户向社区共建者转变。</p>`,
    category: 'ziyuan-tuijian',
    categoryName: '资源推荐',
    image: 'https://readdy.ai/api/search-image?query=Community%20interaction%20and%20social%20connection%20concept%2C%20connected%20people%20abstract%2C%20warm%20amber%20and%20cream%20tones%2C%20minimalist%20geometric%20design%2C%20friendly%20and%20engaging%20atmosphere&width=800&height=480&seq=article-10&orientation=landscape',
    author: '91暗指南编辑部',
    date: '2026-07-05',
    readTime: '11分钟',
    featured: false,
  },
  {
    id: 11,
    slug: '91an-pingbi-jiejue-fangan',
    title: '91暗访问受限解决方案：多种方式确保畅通',
    excerpt: '遇到91暗访问受限的情况怎么办？本文提供多种实用的解决方案，帮助您在任何情况下都能顺畅使用91暗。',
    content: `<p>在使用<strong>91暗</strong>的过程中，有时可能会遇到访问受限的情况。本文为您整理了多种解决方案，确保您能够持续稳定地使用91暗。</p>

<h2>常见访问问题诊断</h2>
<p>首先，我们需要准确判断访问受限的具体原因，这样才能采取针对性的解决方案。</p>

<h2>多种解决方案</h2>
<p>根据不同的访问问题，我们提供了以下几种解决方案供您选择。</p>

<h2>预防措施</h2>
<p>与其事后解决问题，不如提前做好预防。以下是一些减少访问问题的预防措施。</p>`,
    category: 'rukou-dizhi',
    categoryName: '入口地址',
    image: 'https://readdy.ai/api/search-image?query=Network%20access%20and%20connectivity%20solution%20concept%2C%20abstract%20bridges%20and%20pathways%2C%20warm%20golden%20tones%2C%20minimalist%20design%2C%20reliable%20and%20stable%20feeling&width=800&height=480&seq=article-11&orientation=landscape',
    author: '91暗指南编辑部',
    date: '2026-06-28',
    readTime: '7分钟',
    featured: false,
  },
  {
    id: 12,
    slug: '91an-guanfang-qudao-quanwei-renzheng',
    title: '91暗官方渠道权威认证指南',
    excerpt: '如何辨别真正的91暗官方渠道？本文教您识别官方认证标识，避免被仿冒渠道误导，确保您使用的是正版91暗服务。',
    content: `<p>辨别<strong>91暗官方渠道</strong>的真实性是保障使用体验和安全的关键。本文将为您提供全面的官方渠道识别指南。</p>

<h2>官方渠道的特征</h2>
<p>真正的91暗官方渠道具有一些独特的标识和特征，了解这些特征可以帮助您快速辨别真伪。</p>

<h2>常见仿冒手段</h2>
<p>了解常见的仿冒手段，可以提高您的警惕性，避免上当受骗。</p>

<h2>验证方法汇总</h2>
<p>我们整理了几种简单有效的验证方法，帮助您确认所使用的渠道是否为91暗官方渠道。</p>`,
    category: 'rukou-dizhi',
    categoryName: '入口地址',
    image: 'https://readdy.ai/api/search-image?query=Official%20certification%20and%20authentication%20concept%2C%20badge%20and%20checkmark%20symbols%2C%20warm%20cream%20and%20gold%20tones%2C%20minimalist%20clean%20design%2C%20trustworthy%20and%20authoritative%20style&width=800&height=480&seq=article-12&orientation=landscape',
    author: '91暗指南编辑部',
    date: '2026-06-20',
    readTime: '5分钟',
    featured: false,
  },
];

export const faqs = [
  {
    question: '91暗是什么？',
    answer: '91暗是一个综合性的内容平台，集成了丰富的资源和便捷的功能，为用户提供多元化的在线体验。它涵盖了多个领域的内容，并通过持续更新保持新鲜度，是当前互联网上备受关注的热门平台之一。',
  },
  {
    question: '如何找到91暗的最新入口地址？',
    answer: '您可以通过关注本站的"入口地址"分类栏目获取最新的91暗入口信息。我们定期验证和更新91暗入口地址，确保提供的信息准确可靠。建议将本站加入收藏夹，以便随时查阅最新地址。',
  },
  {
    question: '91暗使用需要注册账号吗？',
    answer: '91暗的基本浏览功能通常不需要注册账号，但注册账号后可以解锁更多高级功能，如个性化推荐、内容收藏、社区互动等。我们建议用户注册账号以获得完整的使用体验。',
  },
  {
    question: '91暗是否免费使用？',
    answer: '91暗的基础功能是免费提供的，用户可以自由浏览和使用大部分内容。部分高级功能或专属内容可能需要付费，具体以平台官方说明为准。',
  },
  {
    question: '使用91暗时如何确保安全？',
    answer: '为确保安全使用91暗，建议您：1）通过官方认证渠道访问；2）使用强密码并定期更换；3）不在公共设备上保存登录信息；4）注意保护个人隐私信息；5）定期检查账户安全设置。',
  },
  {
    question: '91暗支持哪些设备访问？',
    answer: '91暗支持多种设备的访问，包括桌面电脑（Windows、macOS）、移动设备（iOS、Android）以及平板电脑。平台针对不同设备进行了适配优化，确保在各种屏幕尺寸上都能获得良好的使用体验。',
  },
  {
    question: '91暗的内容更新频率如何？',
    answer: '91暗的内容更新频率较高，平台团队会根据用户需求和行业动态持续更新内容。一般来说，核心内容每周都会有更新，热门板块可能每日都有新内容上线。',
  },
  {
    question: '如何联系91暗的客服支持？',
    answer: '您可以通过91暗官方网站的联系页面提交问题，或通过站内反馈功能直接与技术支持团队取得联系。此外，也可以通过本站的"关于我们"页面了解更多联系方式和反馈渠道。',
  },
];

export const testimonials = [
  {
    name: '张先生',
    role: '资深用户',
    content: '使用91暗已经两年了，这个平台的内容质量和更新速度一直让我很满意。特别是它的资源整合能力，帮我节省了大量搜索和筛选的时间。',
    rating: 5,
  },
  {
    name: '李女士',
    role: '内容创作者',
    content: '作为一个内容创作者，91暗为我提供了丰富的创作灵感和素材来源。平台的社区氛围也很好，用户之间的交流非常活跃和有价值。',
    rating: 5,
  },
  {
    name: '王同学',
    role: '大学生用户',
    content: '朋友推荐我使用91暗，一开始只是为了查找资料，后来发现这里的内容远超预期。现在它已经成为我日常学习和娱乐的重要工具。',
    rating: 4,
  },
  {
    name: '赵经理',
    role: '行业从业者',
    content: '从行业角度来看，91暗在内容生态建设方面做得非常出色。它的分类体系清晰合理，内容质量把控严格，是行业内值得关注的标杆平台。',
    rating: 5,
  },
];